// EmojiPicker.js
import React from 'react';

const EmojiPicker = ({ onEmojiSelect, onClose }) => {
  const allowedEmojis = [
    '😊', '😄', '😁', '😅', '😆', '😂', '🤣', '😋', '😉', '😎',
    '😍', '😙', '😘', '🥰', '🤨', '😮', '🙄', '😏', '😣', '😥',
    '😪', '😭', '😴', '😵', '🤒', '🤕', '🤮', '🥳', '🤭', '🤷‍♀️',
    '🤷‍♂️', '👣', '💑', '👨‍👩‍👧', '👨‍👩‍👦', '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', 
    '👨‍👩‍👧‍👧', '👭', '👫', '👴', '👵', '👨', '👦', '👶', '🤴', 
    '👸', '👍', '👎', '👌', '👏', '👊', '👋', '🙏', '🤝', '🎂', 
    '🎉', '🎊', '🎃', '🎄', '🎑', '🎁', '👑', '🥉', '🏆', '🎶',
    '🍕', '🍔', '🍟', '🌭', '🍦', '🍩', '🧁', '🍫', '☕', '🥂',
    '🍻', '🍺', '💐', '🌺', '🥀', '🌱', '🍁', '🌟', '⭐', '🌞',
    '🌜', '☔', '🌄', '✈', '🚅', '🚌', '🚗'
  ];
   
  return (
    <div className="position-relative p-3 ">
  {/* Close button in the top-right corner */}
  <button
    className="btn position-absolute top-0 end-0 fs-5 text-danger" // text-danger makes it red
    onClick={onClose}
    aria-label="Close"
  > 
<i class="fa-solid fa-xmark text-danger font-size-16"></i>
  </button>

  {/* Emoji buttons */}
  <div className="d-flex flex-wrap mt-3">
    {allowedEmojis.map((emoji, index) => (
      <button
        key={index}
        className="btn btn-link p-2 fs-4"
        onClick={() => onEmojiSelect(emoji)}
      >
        {emoji}
      </button>
    ))}
  </div>
</div>

  );
};

export default EmojiPicker;
